import { loadTemplate } from "utils/load_template"
import { CustomControlBase } from "wistia/player_controls/custom_control_base"
import VideoDataStore from "models/video_data_store"

class CustomSeekControl extends CustomControlBase {
  constructor (video, options) {
    super(video, options)
    this.moveTo = options.moveTo || ((t) => { return t })
  }

  mountButton(buttonRoot) {
    this.buttonRoot = buttonRoot
    this.updateButtonText()
    this.setButtonLabel(this.buttonLabel)
  }

  onClickButton (event) {
    this.video.time(this.moveTo(this.video))
  }

  updateButtonText () {
    this.buttonRoot.innerHTML = this.buttonText
  }
}

export class BackwardControl extends CustomSeekControl {
  constructor(video) {
    super(video, {
      moveTo: (video) => {
        return Math.max(0, video.time() - 15)
      },
      buttonText: loadTemplate("cle-video-player-backward-control-template"),
      buttonLabel: "Rewind 15 sec."
    })
  }
}
BackwardControl.sortValue = 3
BackwardControl.handle = 'backwardControl'

export class ForwardControl extends CustomSeekControl {
  constructor(video) {
    super(video, {
      moveTo: (video) => {
        return Math.min(video.time() + 15, this.getDataStore().getMaxWatchedSecond())
      },
      buttonText: loadTemplate("cle-video-player-forward-control-template"),
      buttonLabel: "Skip 15 sec."
    })
  }
}
ForwardControl.sortValue = 200
ForwardControl.handle = 'forwardControl'

export class StepForwardControl extends CustomSeekControl {
  constructor(video) {
    super(video, {
      moveTo: (video) => {
        return this.getDataStore().getMaxWatchedSecond()
      },
      buttonText: loadTemplate("cle-video-player-step-forward-control-template"),
      buttonLabel: "Jump to max second viewed"
    })
  }
}
StepForwardControl.sortValue = 201
StepForwardControl.handle = 'stepForwardControl'
